import { render } from "./alert_report.vue?vue&type=template&id=440a9e6c&scoped=true"
import script from "./alert_report.js?vue&type=script&lang=js"
export * from "./alert_report.js?vue&type=script&lang=js"

import "./alert_report.vue?vue&type=style&index=0&id=440a9e6c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440a9e6c"]])

export default __exports__